const checklistServiceButton = {
  create: 'CREAR SERVICIO',
  scroll: 'IR A PREGUNTA NO RESPONDIDA',
  needAction: 'IR A LA PREGUNTA SIN ACCIÓN',
  needSignatures: 'NECESARIO AGREGAR FIRMA',
};

export default checklistServiceButton;